//* ------------------------------------*\
//    $MISC STRINGS
//* -----------------------------------*/

const MISC = {
  ALL: 'all',
  BEFOREEND: 'beforeend',
  BEM_ELEMENT: '__',
  BEM_MODIFIER: '--',
  CFGOGEO: 'cfgogeo',
  CHANGE: 'Change ',
  CLEAR_FILTER: 'Clear Filter',
  CLOSE: 'Close',
  CLOSE_FILTERS: 'Close Filters',
  DATA_VISIBLE: 'data-visible',
  ELECTION_TYPE: 'election_type',
  END_TIMESTAMP: 'end_timestamp',
  EVENT_TYPE: 'event_type',
  EVENT_TYPE_PARAM: 'e_types',
  EYE_BLINK: 'EyeBlink',
  FALSE: 'false',
  FILTERS: 'Filters',
  HEIGHT: 'height',
  INCLUDE_EMAIL_SIGNUP: 'include_email_signup',
  IN_VIEWPORT: 'in-viewport',
  MENU: 'Menu',
  MOBILIZE_IMAGE_PARAMS: '?auto=format&crop=faces&fit=crop&h=182.29&w=350',
  MQ_HOVER: '(hover: hover)',
  MQ_NO_ANY: '(any-hover: none), (any-pointer: coarse)',
  mURL1: 'mailto:',
  mURL2: '?subject=',
  mURL3: '&body=',
  NAME: 'name',
  NO: 'no',
  NO_RESULTS: 'There are no posts that match that filter combination.',
  POPUP: 'popup',
  POST: 'post',
  POSTS: 'posts',
  PROGRAM_PARAM: 'program',
  PUBLISH: 'publish',
  RETURNING: 'goreturning',
  SQUERY: '&s=',
  START_TIMESTAMP: 'start_timestamp',
  STATE_PARAM: 'us_state',
  STATECODE: 'gostatecode',
  SUBMITTED: 'submitted',
  TABINDEX: 'tabindex',
  TRUE: 'true',
  VALUE: 'value',
  WIDTH: 'width',
  ZIPCODE: 'gozipcode',
  ZIP_PARAM: 'us_zip',
  CALL_STATE_CODE: 'callstatecode'
};

export default MISC;
